module.exports = __webpack_public_path__ + "static/media/garage.fa1762c7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/objects/characteristics/garage.svg
// module id = 868
// module chunks = 0